import React from "react";

function LogoLoader({ theme }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 440 305"
      width="50%"
      height="40%"
      className="raw_logo"
    >
      <style>{`
        .hexagon {
          fill: none;
          stroke: ${theme ? theme.imageHighlight : "#2196f3"};
          stroke-width: 3;
          stroke-dasharray: 800;
          stroke-dashoffset: 800;
          animation: drawHex 1.2s ease forwards;
        }
        .initials {
          fill: none;
          stroke: ${theme ? theme.imageHighlight : "#2196f3"};
          stroke-width: 1.5;
          stroke-dasharray: 400;
          stroke-dashoffset: 400;
          animation: drawText 1.5s ease 0.8s forwards;
          font-family: 'Segoe UI', Georgia, serif;
          font-size: 72px;
          font-weight: 200;
          letter-spacing: 8px;
        }
        .name-text {
          fill: none;
          stroke: ${theme ? theme.imageHighlight : "#2196f3"};
          stroke-width: 1;
          stroke-dasharray: 800;
          stroke-dashoffset: 800;
          animation: drawText 1.8s ease 1.8s forwards;
          font-family: 'Segoe UI', sans-serif;
          font-size: 22px;
          font-weight: 200;
          letter-spacing: 8px;
        }
        @keyframes drawHex {
          to { stroke-dashoffset: 0; }
        }
        @keyframes drawText {
          to { stroke-dashoffset: 0; }
        }
      `}</style>

      {/* Hexagon frame */}
      <polygon
        className="hexagon"
        points="220,30 310,80 310,180 220,230 130,180 130,80"
      />

      {/* "SM" initials */}
      <text className="initials" x="220" y="160" textAnchor="middle">
        SM
      </text>

      <text className="name-text" x="220" y="265" textAnchor="middle">
        Yousef Injas
      </text>
    </svg>
  );
}

export default LogoLoader;
